<template>
    <div class="white-wrapper">
        <div v-if="!detailPage" class="container__background"/>
        <div v-if="detailPage" class="project-navigation">
            <p>Projeler - Anasayfa</p>
            <a href="/projeler">« Geri</a>
        </div>
        <component v-if="detailPage" :is="detailPage"/>
        <div v-if="!detailPage" class="container__wrapper">
            <div class="container__kuyucuk">
                <div class="container__item item-1">
                    <div class="container__image">
                        <img src="../assets/sub_page_images/kuyucuk-bg-1-2@2x.png">
                    </div>
                    <div class="container__text">
                        <span class="container__text-title">KUYUCUK KUŞ CENNETİ KURUYOR</span>
                        <span class="container__text-description">
                                    <span class="container__text-bold">232 kuş</span> türüne ev sahipliği yapan Kuyucuk Gölü
                                    kuruma tehlikesiyle karşı karşıya.</span>
                    </div>
                </div>
                <div class="container__item item-2">
                    <div class="container__image">
                        <img src="../assets/sub_page_images/kuyucuk-bg-2-2@2x.png">
                    </div>
                    <div class="container__text">
                        <span class="container__text-title">KUYUCUK GÖLÜ</span>
                        <p>Kars şehir merkezine 37 km uzaklıkta bulunan Kuyucuk Gölü, adını Arpaçay ilçesine bağlı
                            Kuyucuk köyünden alır. Tatlı su gölü olan Kuyucuk Gölü, Afrika-Avrasya göç̧ yolu
                            üzerinde bulunur Kuzey Doğa Derneği tarafından yapılan çalışmalarda 232 kuş türünün
                            alanı kullandığı belirlenmiştir.
                        </p><br>
                        <p>Alan, Önemli Kuş Alanı (TR089) ve Önemli Doğa Alanı’dır (DOG025). 2005 yılında Tarım ve
                            Orman Bakanlığı tarafından Yaban Hayatı Geliştirme Sahası ilan edilen Kuyucuk Golü̈,
                            Doğu Anadolu’nun ilk RAMSAR alanı, Türkiye’nin ise 13. RAMSAR alanıdır.
                        </p><br>
                        <p>Bu da Kuyucuk Gölü’nün Samsun-Adana hattının doğusundaki ilk ve tek RAMSAR alanı olduğu
                            anlamına gelir.
                        </p>
                    </div>
                </div>
                <div class="container__item item-3">
                    <div class="container__image">
                        <img src="../assets/sub_page_images/kuyucuk-bg-3-2@2x.png">
                    </div>
                    <div class="container__text">
                        <span class="container__text-title">KUYUCUK GÖLÜ KUŞ CENNETİ KURUYOR</span>
                        <p>Kuyucuk Gölü, doğal yüzeysel sular ile beslenen bir göldür. Bu yüzden ilkbahar aylarında
                            eriyen kar suları ve bunu izleyen aylarda gelen yağışların Kuyucuk Gölü’ne ulaşması
                            gerekmektedir. Ancak mevcut göletler, yüzeysel suyun Kuyucuk Gölü’ne ulaşmasını
                            engellemekte. Sıcaklığın haziran ayından itibaren artması da gölün kısmı kurumasına,
                            temmuz ayı ortasında ise tamamen kurumasına neden olmaktadır.</p>
                    </div>
                </div>
            </div>
            <div class="news">
                <div class="news__wrapper">
                    <div class="news__big-title">
                        <span>GÜNCELLEMELER</span>
                    </div>
                    <div class="news__item-wrapper">
                        <carousel :autoplay="false" :nav="false" :dots="false"
                                  :responsive="{768:{items:1}, 800: {items: 1}, 1024: {items: 3}}" :stagePadding=0
                                  :margin=20>
                            <div class="item">
                                <span class="news__item-title">Kuyucuk Gölüne Su Verildi - İzle</span>
                                <img src="@/assets/sub_page_images/kuyucuk-video.png" alt="" style="cursor: pointer"
                                     onclick="window.open('/projeler/kuyucuk')">
                                <div class="news__detail">
                                    <router-link to="/projeler/kuyucuk" class="news__detail-url"
                                                 target="_blank">detay
                                        <div class="news__detail-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                 viewBox="0 0 23 23">
                                                <g>
                                                    <path d="M20.52 13.872v2.088c0 2.52-2.04 4.56-4.56 4.56H6.84c-2.52 0-4.56-2.04-4.56-4.56V6.865c0-2.52 2.04-4.56 4.56-4.56h2.064c-.072-.385-.144-.745-.144-1.153 0-.407.048-.767.144-1.152H6.84C3.072 0 0 3.072 0 6.865v9.095c0 3.792 3.072 6.84 6.84 6.84h9.096c3.792 0 6.84-3.072 6.84-6.84v-2.064c-.336.072-.72.144-1.128.144-.408 0-.768-.072-1.128-.168z"/>
                                                    <path d="M21.648 0h-8.592c-.625 0-1.153.504-1.153 1.152 0 .648.505 1.152 1.153 1.152h5.832L7.224 13.944c-.455.456-.455 1.176 0 1.608.216.216.505.336.816.336.288 0 .575-.12.815-.336L20.52 3.888V9.72c0 .624.504 1.152 1.152 1.152.648 0 1.152-.504 1.152-1.152V1.152C22.8.504 22.296 0 21.648 0z"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="item">
                                <span class="news__item-title">Kuyucuk Gölü sayende can suyuna kavuştu, umut dolu hikayemiz başladı!</span>
                                <p class="news__item-description">Projede emeği geçen Kars Valiliği, DSİ ve KuzeyDoğa
                                    Derneği'ne ve sizlere, destekleriniz için binlerce teşekkür ederiz. Arkadaşlarını
                                    etiketleyerek hikayemize ortak olmaya davet et. Kuş Cennetimiz Kuyucuk'a, kuşların
                                    dönüşüne hep birlikte tanık olalım. #HalaUmutVar</p>
                                <div class="news__detail">
                                    <a href="https://youtu.be/AAodDxFIClA" class="news__detail-url"
                                       target="_blank">detay
                                        <div class="news__detail-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                 viewBox="0 0 23 23">
                                                <g>
                                                    <path d="M20.52 13.872v2.088c0 2.52-2.04 4.56-4.56 4.56H6.84c-2.52 0-4.56-2.04-4.56-4.56V6.865c0-2.52 2.04-4.56 4.56-4.56h2.064c-.072-.385-.144-.745-.144-1.153 0-.407.048-.767.144-1.152H6.84C3.072 0 0 3.072 0 6.865v9.095c0 3.792 3.072 6.84 6.84 6.84h9.096c3.792 0 6.84-3.072 6.84-6.84v-2.064c-.336.072-.72.144-1.128.144-.408 0-.768-.072-1.128-.168z"/>
                                                    <path d="M21.648 0h-8.592c-.625 0-1.153.504-1.153 1.152 0 .648.505 1.152 1.153 1.152h5.832L7.224 13.944c-.455.456-.455 1.176 0 1.608.216.216.505.336.816.336.288 0 .575-.12.815-.336L20.52 3.888V9.72c0 .624.504 1.152 1.152 1.152.648 0 1.152-.504 1.152-1.152V1.152C22.8.504 22.296 0 21.648 0z"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="item">
                                <span class="news__item-title">KuzeyDoğa Derneği ile Kuyucuk için neler yapıyoruz?</span>
                                <p class="news__item-description">Yarının Suyu'nu bugünden korumak için bir araya
                                    geldiğimiz projemizde neler yapıldığını bir de @kuzeydoga_dernegi Yönetim Kurulu
                                    Başkanı @cagansekercioglu’ndan dinleyelim. Ekiplerin kıymetli çabaları ve sizlerin
                                    desteğiyle Kuyucuk için #HalaUmutVar</p>
                                <div class="news__detail">
                                    <a href="https://youtu.be/bc9n9n5Ke8k" class="news__detail-url"
                                       target="_blank">detay
                                        <div class="news__detail-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                 viewBox="0 0 23 23">
                                                <g>
                                                    <path d="M20.52 13.872v2.088c0 2.52-2.04 4.56-4.56 4.56H6.84c-2.52 0-4.56-2.04-4.56-4.56V6.865c0-2.52 2.04-4.56 4.56-4.56h2.064c-.072-.385-.144-.745-.144-1.153 0-.407.048-.767.144-1.152H6.84C3.072 0 0 3.072 0 6.865v9.095c0 3.792 3.072 6.84 6.84 6.84h9.096c3.792 0 6.84-3.072 6.84-6.84v-2.064c-.336.072-.72.144-1.128.144-.408 0-.768-.072-1.128-.168z"/>
                                                    <path d="M21.648 0h-8.592c-.625 0-1.153.504-1.153 1.152 0 .648.505 1.152 1.153 1.152h5.832L7.224 13.944c-.455.456-.455 1.176 0 1.608.216.216.505.336.816.336.288 0 .575-.12.815-.336L20.52 3.888V9.72c0 .624.504 1.152 1.152 1.152.648 0 1.152-.504 1.152-1.152V1.152C22.8.504 22.296 0 21.648 0z"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="item">
                                <span class="news__item-title">Kuyucuk Gölü’nden gelen bu harika görüntüler.</span>
                                <p class="news__item-description">🤗Kuyucuk Gölü için umudumuz artık her zamankinden
                                    daha fazla!</p>
                                <div class="news__detail">
                                    <a href="https://youtu.be/otBfQFf_4Kc" class="news__detail-url"
                                       target="_blank">detay
                                        <div class="news__detail-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                                 viewBox="0 0 23 23">
                                                <g>
                                                    <path d="M20.52 13.872v2.088c0 2.52-2.04 4.56-4.56 4.56H6.84c-2.52 0-4.56-2.04-4.56-4.56V6.865c0-2.52 2.04-4.56 4.56-4.56h2.064c-.072-.385-.144-.745-.144-1.153 0-.407.048-.767.144-1.152H6.84C3.072 0 0 3.072 0 6.865v9.095c0 3.792 3.072 6.84 6.84 6.84h9.096c3.792 0 6.84-3.072 6.84-6.84v-2.064c-.336.072-.72.144-1.128.144-.408 0-.768-.072-1.128-.168z"/>
                                                    <path d="M21.648 0h-8.592c-.625 0-1.153.504-1.153 1.152 0 .648.505 1.152 1.153 1.152h5.832L7.224 13.944c-.455.456-.455 1.176 0 1.608.216.216.505.336.816.336.288 0 .575-.12.815-.336L20.52 3.888V9.72c0 .624.504 1.152 1.152 1.152.648 0 1.152-.504 1.152-1.152V1.152C22.8.504 22.296 0 21.648 0z"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </carousel>

                        <div class="what-we-do__buttons">
                            <div class="what-we-do__prev-button" v-on:click="owlPrevNews">
                                <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58">
                                    <path d="M57.887 29.141c0-15.738-12.762-28.5-28.5-28.5s-28.5 12.762-28.5 28.5 12.762 28.5 28.5 28.5 28.5-12.762 28.5-28.5zm-34.258-.016l9.402-9.363 1.41 1.418-8.003 7.973 8.02 8.293-1.438 1.39-9.391-9.71z"/>
                                </svg>
                            </div>
                            <div class="what-we-do__next-button" v-on:click="owlNextNews">
                                <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58">
                                    <path d="M.113 28.859c0 15.738 12.762 28.5 28.5 28.5s28.5-12.762 28.5-28.5-12.762-28.5-28.5-28.5-28.5 12.762-28.5 28.5zm34.258.016l-9.402 9.363-1.41-1.418 8.003-7.973-8.02-8.293 1.438-1.39 9.391 9.71z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";
    import carousel from 'vue-owl-carousel'
    //import Kuyucuk from "../sub-projects/Kuyucuk";
    import Kuyucuk from "../sub-projects/Kuyucuk-2";

    export default {
        name: "Projects",
        data() {
            return {
                projectPage: false,
                detailPage: Object,
                pages: {
                    'kuyucuk': Kuyucuk,
                    //'kuyucuk-2' : Kuyucuk2
                }
            }
        },
        components: {carousel},
        methods: {
            owlPrevNews: function (event) {
                $('.news__item-wrapper > div > .owl-carousel > .owl-nav > .owl-prev').click();
            },
            owlNextNews: function (event) {
                $('.news__item-wrapper > div > .owl-carousel > .owl-nav > .owl-next').click();
            },
            owlPrevWhatWeDo: function (event) {
                $('.what-we-do__wrapper > div > .owl-carousel > .owl-nav > .owl-prev').click();
            },
            owlNextWhatWeDo: function (event) {
                $('.what-we-do__wrapper > div > .owl-carousel > .owl-nav > .owl-next').click();
            }
        },
        mounted() {
            this.projectPage = false;
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
            if (this.$route.params) {
                this.projectPage = true;
                this.detailPage = this.pages[this.$route.params.project];
            } else {
                this.projectPage = false;
            }
        }
    }
</script>


<style lang="scss">

    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


    .white-wrapper {

        background-color: white;
        width: 100%;
        
        .project-navigation {
            background-image: url('../assets/sub_page_images/heder@2x.png');
            display: flex;
            padding: 10px 150px;
            background-size: cover;
            background-position: top;
            flex-direction: column;

            @media only screen and (max-device-width: 768px) {
                padding: 10px 40px;
            }

            a,
            a:visited,
            a:link,
            a:active,
            p {
                color: black;
                font-family: Quicksand;
                font-size: 15px;
                font-weight: bold;
                text-decoration: none;
                margin: 3px 0;
                @media only screen and (max-device-width: 768px) {
                    font-size: 45px;
                }
            }
        }
    }

    .title {
        display: flex;
        color: #000000 !important;
        font-size: 25px;
        margin-bottom: 50px;
        margin-top: 50px;
        font-weight: bold;

        @media (max-device-width: 768px) {
            width: 100%;
            font-size: 50px;
            padding: 30px 30px;
        }
    }

    .text {
        display: flex;
        width: 100%;
        margin-bottom: 100px;
        flex-direction: column;
        
        align-items: center;

        

        & > img {
            width: 100%;
            display: flex;
            cursor: pointer;

            @media (max-device-width: 768px) {
                height: 100%;
            }
        }

        @media (max-device-width: 768px) {
            width: 100%;
            padding: 30px 30px;
            font-size: 30px;
        }
    }

    .container {
        position: relative;
        padding-top: 100px;
        color: black;
        width: 1140px;
        margin: 0px auto;
        padding: 100px 0px;

        &__background {
            height: 460px;
            background-image: url('../assets/sub_page_images/heder@2x.png');
            background-size: cover;
            position: absolute;
            width: 100%;
            top: 0px;
        }

        &__wrapper {
            width: $base-width;
            background-color: white;
            margin: 0 auto;
            padding-top: 100px !important;
            @media (max-device-width: 768px) {
                width: 90%;
            }
        }

        &__image {
            width: 1140px;
            box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
            border-radius: 20px;
            overflow: hidden;

            > img {
                width: 100%;
                display: flex;
            }

            @media (max-device-width: 768px) {
                width: 100%;
            }
        }

        &__item {
            position: relative;
        }


        &__text {
            width: 564px;
            height: auto;
            border-radius: 10px;
            box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
            background-color: rgba(0, 0, 0, 0.75);
            padding: 50px;
            position: absolute;
            @media (max-device-width: 768px) {
                width: 100%;
                position: initial;
                margin-top: 50px;
            }

            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            > p {
                font-size: 16px;
            }
            
        }
        
        &__text::after {
            content: '';
            position: absolute;
            border-radius: 10px;
            border: solid 1px #bdbdbd;
            bottom: 0;
            left: 20px;
            width: 100%;
            height: 100%;
            top: 25px;
        }

        &__text-title {
            font-size: 35px;
            font-weight: bold;
            margin-bottom: 40px;
            @media (max-device-width: 768px) {
                font-size: 25px;
            }
        }

        &__text-description {
            font-weight: normal;
            font-size: 25px;
        }

        &__text-bold {
            font-weight: bold;
        }

        &__kuyucuk {
            margin-bottom: 300px;
            @media (max-device-width: 768px) {
                margin-bottom: 100px;
            }
        }
        & .text > iframe {
            width: 50%;
        }
    }

    .item-1 {
        margin-bottom: 166px;
        @media (max-device-width: 768px) {
            margin-top: 50px;
            margin-bottom: 50px;
        }

        > .container__image {
            margin-left: -60px;

            @media (max-device-width: 768px) {
                margin: 0px;
            }
        }

        > .container__text {
            bottom: -107px;
            right: 0;
        }
    }

    .item-2 {
        margin-bottom: 360px;
        @media (max-device-width: 768px) {
            margin-bottom: 50px;
        }

        > .container__image {
            margin-left: 60px;
            @media (max-device-width: 768px) {
                margin: 0px;
            }
        }

        > .container__text {
            bottom: -250px;
            left: 0;
        }

        > .container__text::after {
            left: -20px;
        }
    }

    .item-3 {
        margin-bottom: 166px;
        @media (max-device-width: 768px) {
            margin-bottom: 0px;
        }

        > .container__text {
            bottom: -215px;
            right: 0;
        }

        > .container__image {
            margin-left: -60px;
            @media (max-device-width: 768px) {
                margin: 0px;
            }
        }
    }

    .what-we-do {
        width: 100%;
        margin: 0px auto;
        margin-bottom: 100px;

        @media (max-device-width: 768px) {
            width: 90%;
            margin: 0px auto;
            margin-bottom: 50px;
        }

        &__wrapper {
            margin: 0 60px;
            height: 100%;
            align-items: center;
            @media (max-device-width: 768px) {
                margin: 0px;
            }

            & > div > .owl-carousel > .owl-stage-outer {
                width: 100%;
            }
        }

        &__item {
            display: flex;
            align-items: center;
            justify-content: center;

            @media (max-device-width: 768px) {
                margin-bottom: 50px;
                flex-direction: column;
            }
        }

        &__item-image {
            width: 328px;
            box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
            border-radius: 10px;
            overflow: hidden;
            @media (max-device-width: 768px) {
                width: 100%;
            }
            margin: 0px !important;

            > img {
                width: 100%;
                display: flex;
                margin: 0px !important;
            }
        }

        &__item-text {
            width: 564px;
            height: 330px;
            border-radius: 10px;
            box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
            background-color: rgba(0, 0, 0, 0.75);
            margin: 50px 50px 20px 50px;
            color: white;
            padding: 20px 52px 0px 52px;
            display: flex;
            flex-direction: column;
            align-items: center;

            @media (max-device-width: 768px) {
                width: 100%;
                flex-direction: column;
                margin: 100px 0px;
                height: auto;
                padding: 60px 60px;
            }

            > p {
                @media (max-device-width: 768px) {
                    font-size: 20px;
                }
            }
        }

        &__item-text-title {
            font-size: 35px;
            margin-bottom: 20px;
            font-weight: bold;
            text-align: center;

            @media (max-device-width: 768px) {
                font-size: 45px;
            }
        }

        &__buttons {
            display: flex;
            align-items: center;
            justify-content: center;

        }

        &__prev-button {
            display: flex;
            width: 57px;
            margin: 0px 30px;
            @media (max-device-width: 768px) {
                margin: 0px 10px;
            }
            cursor: pointer;

            > svg {
                width: 100%;
            }
        }

        &__next-button {
            display: flex;
            cursor: pointer;
            width: 57px;
            margin: 0px 30px;

            > svg {
                width: 100%;
            }

            @media (max-device-width: 768px) {
                margin: 0px 10px;
            }
        }
    }

    .news {
        margin-bottom: 290px;

        &__wrapper {
            width: 1140px;
            height: 250px;
            margin: 0 auto;
            border-radius: 10px;
            box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
            background-color: rgba(0, 0, 0, 0.75);
            position: relative;

            @media (max-device-width: 768px) {
                width: 90%;
            }
        }

        &__wrapper::after {
            content: '';
            position: absolute;
            top: -20px;
            left: 20px;
            border-radius: 10px;
            border: solid 1px #bdbdbd;
            width: 100%;
            height: 100%;
        }

        &__big-title {
            font-size: 25px;
            font-weight: bold;
            color: white;
            padding: 20px 44px;

        }

        &__item-wrapper {
            width: calc(100% - 19px);
            height: 250px;

            position: absolute;
            left: 40px;
            z-index: 1;

            @media (max-device-width: 768px) {
                width: 100%;
                left: 20px;
            }
        }

        &__item {
            height: 100%;
            margin-right: 20px;

        }

        &__item-title {
            font-size: 15px;
            font-weight: bold;
            color: black;
            @media only screen and (max-device-width: 768px) {
                font-size: 34px;
            }
        }

        &__item-description {
            margin-top: 10px;
            font-size: 15px;
            font-weight: normal;
            color: black;
        }

        &__detail {
            display: flex;
            justify-content: flex-end;
            width: 80px;
            margin-left: auto;
            cursor: pointer;
            margin-top: auto;
            @media only screen and (max-device-width: 768px) {
                a {
                    font-size: 35px;
                }
            }
        }

        &__detail-url {
            font-size: 15px;
            font-weight: bold;
            text-decoration: underline;
            color: black;
            display: flex;
        }

        &__detail-icon {
            width: 23px;
            margin-left: 7px;

            > svg {
                width: 100%;
            }
        }

        height: auto;
        display: block;
        &__wrapper {
            @media (max-device-width: 768px) {
                width: 100%;
                height: 460px;
                margin-bottom: 550px;
                overflow: visible;
                display: block;

                &:after {
                    height: 60%;
                }
            }
        }

        &__item-wrapper {
            @media only screen and (max-device-width: 768px) {
                height: auto;
                position: relative;
            }
        }
    }

    .owl-stage-outer {
        position: absolute;
        width: 1140px;
        @media (max-device-width: 768px) {
            width: 100%;
        }
    }

    .item {
        display: flex;
        flex-direction: column;
        padding: 30px 22px;
        border-radius: 10px;
        box-shadow: 15px 13px 20px 0 rgba(0, 0, 0, 0.23);
        background-color: #ffffff;
        min-height: 311px;
    }

    .owl-item {
        padding: 0px 10px 30px 10px;

        img {
            margin-top: 5px;
            object-fit: contain;
        }
    }

    .owl-prev, .owl-next {

        width: 57px;

        > img {
            width: 100%;
        }
    }

    .owl-prev:hover, .owl-next:hover, .what-we-do__prev-button:hover, .what-we-do__next-button:hover {
        background: none !important;
        outline: none !important;
        opacity: 0.6;
    }

    .owl-prev, .owl-next, .what-we-do__prev-button, .what-we-do__next-button {
        outline: none;
        opacity: 1;
        transition: all .5s ease;
    }

    .campaing {
        margin-bottom: 100px;

        &__wrapper {
            width: $base-width;
            margin: 0 auto;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            @media (max-device-width: 768px) {
                width: 90%;
                flex-direction: column;
            }
        }

        &__logo {
            width: 133px;
            margin-right: 100px;

            > img {
                width: 100%;
            }

            @media (max-device-width: 768px) {
                margin: 0px auto;
                margin-bottom: 50px;
            }
        }

        &__promotion {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        &__promotion-text {
            font-size: 25px;
            color: #00bfed;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            p {
                margin: 0;
            }
        }

        &__promotion-button {
            display: flex;
            align-items: center;
            margin: 25px auto;
            padding: 10px;
            background-color: red;
            width: 268px;
            border-radius: 28.5px;
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.22);
            background-image: linear-gradient(to top, #00a0e2, #00c3ee);
            font-size: 15px;
            color: white;
            font-weight: bold;
            justify-content: center;
            text-decoration: none;
        }

        &__promotion-button-icon {
            width: 31px;
            margin-right: 10px;

            > svg {
                width: 100%;
                display: flex;
            }
        }
    }

</style>
